// extracted by mini-css-extract-plugin
export var sbShowMain = "homepageAnimSvg-module--sb-show-main--zFP3A";
export var svg = "homepageAnimSvg-module--svg--oGcbi";
export var icon = "homepageAnimSvg-module--icon--zGe9p";
export var icon2 = "homepageAnimSvg-module--icon2--3EetC";
export var icon3 = "homepageAnimSvg-module--icon3--37VHK";
export var icon4 = "homepageAnimSvg-module--icon4--1qI0R";
export var icon5 = "homepageAnimSvg-module--icon5--qBZW6";
export var icon6 = "homepageAnimSvg-module--icon6--3MriB";